<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  Revisar aprovação · #{{ data.purchaseId }}
</aionz-header-bottom-sheet>

<aionz-dialog-content class="review-content">
  <aionz-approval-review [review]="data" />
</aionz-dialog-content>

<aionz-dialog-actions align="end">
  <button
    matButton="outlined"
    type="button"
    (click)="close()">
    Voltar ao mapa
  </button>
  <button
    matButton="filled"
    type="button"
    class="review-continue"
    [class.review-continue--warning]="data.hasExpired"
    (click)="continue()">
    Confirmar e continuar
  </button>
</aionz-dialog-actions>
